









































import Vue from 'vue'
import PasswordVerificationRules from '@/components/PasswordVerificationRules.vue'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
export default Vue.extend({
    components: { PasswordVerificationRules },
    mixins: [tenantNavMixin],
    props: {
        //  Decides if this is for the auth or not, defaults to being for auth
        userId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            loading: false,
            //  The confirm password
            confirmPassword: null,
            //  The old password
            oldPassword: null,
            //  Container for our password
            password: null,
            //  Show confirm password
            showConfirmPassword: false,
            //  Show old password
            showOldPassword: false,
            showPassword: false,
            //  V-model for user's mobilephone, used for validation purposes
            mobilephone: null
        }
    },
    computed: {
        email(): string {
            return this.$route.query?.email
        },
        token(): string {
            return this.$route.query?.token
        }
    },
    methods: {
        async resetAuthPassword(): Promise<void> {
            //  Construct our payload
            const payload = {
                email: this.email,
                password: this.password,
                token: this.token
            }

            //  Start the loading spinner
            this.loading = true

            //  Send the request to the API
            const response = await this.$store.dispatch('authPasswordReset', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Else, get the auth user which contains if two factor passed and the user
            const auth = await this.$store.dispatch('authUserGet', {'userToken': response.userToken, 'twoFactorToken': response.twoFactorToken})

            //  Pop a notification banner
            this.$store.commit('appNotificationBarSet', {
                message: 'Password Reset Successfully',
                type: 'success'
            })

            //  Route user to appropriate landing page
            this.routeLogin(auth.user)
        },
        async resetUserPassword(): Promise<void> {
            //  Construct our payload
            const payload = {
                confirmPassword: this.confirmPassword,
                oldPassword: this.oldPassword,
                password: this.password,
                id: this.userId
            }

            //  Start the loading spinner
            this.loading = true

            //  Send the request to the API
            const response = await this.$store.dispatch('usersPasswordReset', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Else, lets notify the user
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Password Reset Successfully',
                text: "You have successfully reset this user's password",
                icon: 'mdi-check-circle',
                color: 'primary'
            })

            //  Emit to the parent
            this.$emit('submit', response)
        },
        async resetPassword(): Promise<void> {
            //  Validate the form
            const valid = await this.$validator.validateAll()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  If we have a user id, route to the user update function
            if (this.userId) this.resetUserPassword()
            //  Else, route to auth password reset
            else this.resetAuthPassword()
        }
    }
})
